module.exports = __webpack_public_path__ + "static/media/process_3.1e188b87.png";